import { render, staticRenderFns } from "./McBarChart.vue?vue&type=template&id=2cbea60e&"
import script from "./McBarChart.vue?vue&type=script&lang=js&"
export * from "./McBarChart.vue?vue&type=script&lang=js&"
import style0 from "./McBarChart.vue?vue&type=style&index=0&id=2cbea60e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports